import React from 'react'
import { Grid, Theme, Typography, Button } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import { Modifications as ModificationsType } from '@src/types/graphql-types'
import ModificationDropDownBase from './ModificationDropDownBase'
import FeasibilityMessage from './FeasibilityMessage'
import useFormikHelper from '../../useFormikHelper'
import { InsertModificationArgs } from '../../ProductsConfiguration'

interface InternalModificationsProps {
  disabled: boolean
  internalModData?: ModificationsType
  insertModificationIntoSequence: ({
    value,
    resetMod,
    isAntiSense,
  }: InsertModificationArgs) => Promise<string>
}
const useStyle = makeStyles((theme: Theme) => {
  return {
    buttonContainer: {
      paddingRight: theme.spacing(3),
    },
    infoText: {
      fontSize: theme.typography.pxToRem(12),
    },
  }
})
const InternalModifications: React.FC<InternalModificationsProps> = ({
  disabled,
  internalModData,
  insertModificationIntoSequence,
}) => {
  const classes = useStyle()
  const formik = useFormikHelper()

  const onInternalModChange = (value: string) => {
    formik.setOligoFieldValue('internalMod', value, false)
  }
  const onInternalModCategoryChange = (value: string) => {
    formik.setOligoFieldValue('internalModCategory', value, false)
  }
  const resetMod = () => {
    formik.setOligoFieldValue('internalMod', '', false)
    formik.setOligoFieldValue('internalModCategory', '', false)
  }
  const insertInternalMod = () => {
    formik.selectedOligoValues.internalMod &&
      insertModificationIntoSequence({
        value: formik.selectedOligoValues.internalMod,
        resetMod,
        isAntiSense: false,
      })
  }

  return (
    <>
      <ModificationDropDownBase
        disabled={disabled}
        title={
          <FormattedMessage
            id="CONF_INTERNAL_MOD_TYPE_standard"
            defaultMessage="Internal Modification Type"
          />
        }
        description={
          <FormattedMessage
            id="CONF_INTERNAL_MODIFICATIONS_MESSAGE"
            defaultMessage="Please select your internal modification below. You can clear input to remove modification."
          />
        }
        categoryModifications={internalModData?.category || []}
        onChange={onInternalModChange}
        value={formik.selectedOligoValues.internalMod}
        onCategoryChange={onInternalModCategoryChange}
        categoryValue={formik.selectedOligoValues.internalModCategory}
        enabledModifications={
          formik.selectedOligoValues.enabledInternalModifications
        }
      />
      <Grid container style={{ marginTop: '24px' }}>
        <Grid item xs={3} className={classes.buttonContainer}>
          <Button
            color="primary"
            variant="contained"
            size="medium"
            fullWidth
            disabled={disabled}
            onClick={insertInternalMod}
          >
            <FormattedMessage
              id="CONF_ADD_MODIFICATION"
              defaultMessage="Add Modification"
            />
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Grid item xs={3}>
            <Typography
              component="span"
              variant="body1"
              data-scrub
              className={classes.infoText}
            >
              <FormattedMessage
                id="CONF_INTERNAL_MODIFICATIONS_INSERT_INFO"
                defaultMessage="Insert your cursor at the desired position within the *Sequence field above."
              />
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <FeasibilityMessage />
    </>
  )
}

export default InternalModifications
